function driverLabel(driver) {
  if (!driver) {
    return '';
  }
  return `${driver.firstname || ''} ${driver.lastname || ''}`.trim();
}

export default driverLabel;
